import { MfaPurpose, Tenant } from '@/types'
import { checkSession } from './check-session'
import { authorizeRedirectUri } from './authorize-redirect-uri'

export const loginViaAuth0SSO = async (tenant: Tenant, applyMfa: boolean, temporaryMfaSetup: boolean = false, purpose: string = undefined) => {
  await checkSession(tenant)
  if (applyMfa) {
    await authorizeRedirectUri(tenant, `${window.location.protocol}//${window.location.host}/authenticate?applyMfa=1`, temporaryMfaSetup)
  } else {
    await authorizeRedirectUri(tenant, `${window.location.protocol}//${window.location.host}/authenticate`, temporaryMfaSetup, purpose)
  }
}
